import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { base } from "@reown/appkit/networks";

const projectId =
  process.env.REACT_APP_REOWN_PROJECT_ID || "b56e18d47c72ab683b10814fe9495694";

export const networks = [base];

export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false,
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  defaultNetwork: base,
  metadata: {
    name: "BluePad",
    description: "Launch a coin paired with any Base asset — one transaction opens a Uniswap v4 market.",
    url: typeof window !== "undefined" ? window.location.origin : "https://bluepad.family",
    icons: ["https://bluepad.family/logo.png"],
  },
  features: {
    analytics: false,
    email: false,
    socials: [],
  },
  themeMode: "dark",
  themeVariables: {
    "--w3m-accent": "#0052FF",
    "--w3m-border-radius-master": "3px",
  },
});
